import React from 'react'

import http from 'utils/http'

require('components/styles/layouts/kpi/kpi.styl')

class KpiPage extends React.Component {
  state = {
    odometerValue: null,
    timerId: null,
  }

  componentWillMount() {
    const getMailboxes = () => {
      http
        .get('/members-api/profiles/kpi')
        .then((r) => this.setState({ odometerValue: r?.data?.count }))
    }
    if (!this.state.odometerValue) getMailboxes()
    const timerID = setInterval(() => getMailboxes(), 5 * 60 * 1000)
    this.setState({ timerId: timerID })
  }

  componentWillUnmount() {
    if (this.state.timerId) {
      clearInterval(this.state.timerId)
    }
  }

  render() {
    const { odometerValue } = this.state
    return (
      <div className="kpi-page-container">
        <img className="app-logo" src="/static/webapp/images/ui-logo.png" />
        <div className="center-container">
          <h1 className="app-title">Protected Mailboxes</h1>
          <div className="odometer">{odometerValue && odometerValue.toLocaleString()}</div>
        </div>
      </div>
    )
  }
}

export default KpiPage
